export default "__VITE_ASSET__DodjhFw$__"